'use client';

import { getENV } from '../../utils/env';
import { useConsentGatedInit } from '../hooks';

export const BazaarVoiceV2 = () => {
    const locale = getENV('NEXT_PUBLIC_LOCALE');
    const scriptLocale = locale.replace('-', '_');
    const clientName = locale === 'en-CA' ? 'petsmart-canada' : 'petsmart';
    const environment = getENV('NEXT_PUBLIC_BV_ENVIRONMENT');

    useConsentGatedInit({
        src: `https://apps.bazaarvoice.com/deployments/${clientName}/main_site/${environment}/${scriptLocale}/bv.js`,
        consentGroup: 'C0002',
    });

    return null;
};
